
import React, { Suspense } from "react";
import { Outlet } from "react-router-dom";
import Header from "../../../Ui/Header/header";
const FullLayout = () => {
  return (
    <>
          <Header />
      <Suspense fallback={<>Loading...</>}>
       <Outlet></Outlet>
      </Suspense>
    </>
  );
};
export default FullLayout;
